import { useState } from "react";

const ModalExportarExcel = ({ show, onClose, onExport }) => {
  const [columnas, setColumnas] = useState({
    id: true,
    nombre: true,
    email: true,
    rol: true,
    estado: true,
    creado: true,
  });

  const handleToggle = (columna) => {
    setColumnas({
      ...columnas,
      [columna]: !columnas[columna],
    });
  };

  const handleExportar = () => {
    onExport(columnas);
    onClose();
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Exportar Usuarios a Excel</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p className="text-muted mb-3">
                Selecciona las columnas que deseas exportar:
              </p>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="col-id"
                  checked={columnas.id}
                  onChange={() => handleToggle("id")}
                />
                <label className="form-check-label" htmlFor="col-id">
                  ID
                </label>
              </div>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="col-nombre"
                  checked={columnas.nombre}
                  onChange={() => handleToggle("nombre")}
                />
                <label className="form-check-label" htmlFor="col-nombre">
                  Nombre
                </label>
              </div>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="col-email"
                  checked={columnas.email}
                  onChange={() => handleToggle("email")}
                />
                <label className="form-check-label" htmlFor="col-email">
                  Email
                </label>
              </div>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="col-rol"
                  checked={columnas.rol}
                  onChange={() => handleToggle("rol")}
                />
                <label className="form-check-label" htmlFor="col-rol">
                  Rol
                </label>
              </div>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="col-estado"
                  checked={columnas.estado}
                  onChange={() => handleToggle("estado")}
                />
                <label className="form-check-label" htmlFor="col-estado">
                  Estado
                </label>
              </div>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="col-creado"
                  checked={columnas.creado}
                  onChange={() => handleToggle("creado")}
                />
                <label className="form-check-label" htmlFor="col-creado">
                  Fecha de Creación
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={handleExportar}
              >
                <i className="bi bi-file-earmark-excel me-2"></i>
                Exportar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ModalExportarExcel;
